import React, { FC } from 'react';

interface IComponentProps {
  title: React.ReactNode;
  value?: string | number;
  background?: 'white' | 'blue';
}

export const StatisticsPanelItem: FC<IComponentProps> = ({ title, value = 0, background = 'white' }) => {
  return (
    <div className={`d-flex align-center justify-between statistics-panel-item ${background}`}>
      <div className="ff-medium fs-md statistics-panel-item__title">{title}</div>

      <div className="ff-medium fs-xlg statistics-panel-item__value">{value}</div>
    </div>
  );
};
